import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "mb-10 text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Create an Account", -1)
const _hoisted_4 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Already have an account? ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Sign in here ")
const _hoisted_7 = { class: "row fv-row mb-7" }
const _hoisted_8 = { class: "col-xl-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "First Name", -1)
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "col-xl-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Last Name", -1)
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "row fv-row mb-7" }
const _hoisted_17 = { class: "col-xl-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Salutation", -1)
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "col-xl-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Mobile Number", -1)
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "fv-row mb-7" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Email", -1)
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = {
  class: "mb-10 fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_30 = { class: "mb-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, " Password ", -1)
const _hoisted_32 = { class: "position-relative mb-3" }
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "fv-row mb-5" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Confirm Password", -1)
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "fv-row mb-10" }
const _hoisted_40 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-gray-700 fs-6" }, [
  /*#__PURE__*/_createTextVNode(" I Agree & "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "ms-1 link-primary"
  }, "Terms and conditions"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
      novalidate: "novalidate",
      onSubmit: _ctx.onSubmitRegister,
      id: "kt_login_signup_form",
      "validation-schema": _ctx.registration
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, {
              to: "/sign-in",
              class: "link-primary fw-bolder"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "name",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_ErrorMessage, { name: "name" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "surname",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_ErrorMessage, { name: "surname" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "Salutation",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_ErrorMessage, { name: "Salutation" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "MobileNumber",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_ErrorMessage, { name: "MobileNumber" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "email",
            placeholder: "",
            name: "email",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "password",
                placeholder: "",
                name: "password",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_ErrorMessage, { name: "password" })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "password",
            placeholder: "",
            name: "cpassword",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_ErrorMessage, { name: "cpassword" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("label", _hoisted_40, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "checkbox",
              name: "toc",
              value: "1"
            }),
            _hoisted_41
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("button", _hoisted_43, _hoisted_46, 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}